module.exports = __webpack_public_path__ + "static/media/abracadabra.14562a88.svg";